export type DocumentStatus = "loading" | "not_found" | "error";

export interface StatusCopy {
  title: string;
  description: string;
}

export const STATUS_COPY: Record<DocumentStatus, StatusCopy> = {
  loading: {
    title: "Preparing document",
    description: "Retrieving a secure download link...",
  },
  not_found: {
    title: "Document unavailable",
    description: "This document link is expired or invalid. Please request a new link.",
  },
  error: {
    title: "We hit a snag",
    description:
      "We couldn't load the document. Please refresh or contact support if this continues.",
  },
};
